/**
 * Detects whether the current environment's user agent likely belongs to a bot.
 * Uses a precompiled regular expression against navigator.userAgent.
 *
 * @returns {boolean} True if the user agent matches a known bot pattern, otherwise false.
 */
export function isBot() {
  if (typeof navigator === "undefined" || !navigator.userAgent) {
    return false
  }

  const BOT_PATTERNS = [
    // General
    "bot",
    "spider",
    "crawler",
    "crawl",
    "scraper",
    "robot",
    "fetcher",
    "preview",
    "validator",
    "scan",
    "monitor",

    // Headless / automation
    "headless",
    "phantomjs",
    "selenium",
    "playwright",
    "puppeteer",

    // Search engines & social
    "googlebot",
    "bingbot",
    "yandexbot",
    "baiduspider",
    "duckduckbot",
    "slurp",
    "applebot",
    "facebot",
    "twitterbot",
    "linkedinbot",
    "pinterestbot",
    "whatsapp",
    "discordbot",
    "telegrambot",

    // SEO / analytics crawlers
    "ahrefsbot",
    "semrushbot",
    "mozbot",
    "dotbot",
    "siteaudit",
    "screaming frog",
    "uptimerobot",
    "pingdom",
    "gtmetrix",
    "pagespeed",

    // Security scanners
    "nmap",
    "masscan",
    "nessus",
    "acunetix",

    // Script / CLI HTTP clients
    "wget",
    "curl",
    "python-requests",
    "go-http-client",
    "okhttp",
    "postmanruntime",

    // Generic bot-like patterns
    "bot/",
    "bot-",
    "bot\\d",
  ]

  const BOT_REGEX = new RegExp(BOT_PATTERNS.join("|"), "i")
  return BOT_REGEX.test(navigator.userAgent)
}
